import { apiRequest } from './client';
import { ReviewTask } from '../types';

export type TaskType =
  | 'GOOGLE_REVIEW_WITH_PURCHASE'
  | 'GOOGLE_REVIEW_NO_PURCHASE'
  | 'SOCIAL_CHECKIN'
  | 'HOUSEHOLD_HELP'
  | 'HOME_MOVING'
  | 'PERSONAL_SHOPPING'
  | 'DELIVERY'
  | 'CUSTOMER_REFERRAL'
  | 'MYSTERY_SHOPPER'
  | 'CUSTOM';

export interface CreateTaskInput {
  shopId: string;
  title: string;
  description: string;
  instructions: string;
  rewardCoins: number;
  totalSlots: number;
  checkinRadiusMeters?: number;
  requiredPhotos?: number;
  taskType?: TaskType;
  requiresPurchase?: boolean;
  referralPercentTerms?: string;
  estimatedHours?: number;
  destinationAddress?: string;
  advanceAmountVnd?: number;
}

export function createTask(token: string, input: CreateTaskInput) {
  return apiRequest<ReviewTask>('/tasks', { method: 'POST', token, body: input });
}

/** photoUri is a local file:// (or web blob:) URI from the camera capture. */
export function uploadTaskPhoto(token: string, taskId: string, photoUri: string) {
  const form = new FormData();
  const filename = photoUri.split('/').pop() ?? `photo-${Date.now()}.jpg`;
  const ext = filename.split('.').pop()?.toLowerCase();
  const mime = ext === 'png' ? 'image/png' : 'image/jpeg';
  form.append('photo', { uri: photoUri, name: filename, type: mime } as unknown as Blob);
  return apiRequest<ReviewTask>(`/tasks/${taskId}/photo`, { method: 'POST', token, form });
}

export function myTasks(token: string) {
  return apiRequest<ReviewTask[]>('/tasks/mine', { token });
}

export function getTask(token: string, id: string) {
  return apiRequest<ReviewTask>(`/tasks/${id}`, { token });
}

export function cancelTask(token: string, id: string) {
  return apiRequest<ReviewTask>(`/tasks/${id}/cancel`, { method: 'PATCH', token });
}

export function reportTask(token: string, id: string, reason: string) {
  return apiRequest<{ id: string }>(`/tasks/${id}/report`, { method: 'POST', token, body: { reason } });
}
